import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { LocalstorageService } from "./localstorage.service";

@Injectable({
  providedIn: "root",
})
export class GovSurveyGuardService {
  constructor(
    private router: Router,
    private localstorageService: LocalstorageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let url: string = state.url;
    return this.verifyEmployee(url);
  }

  verifyEmployee(url: string) {
    if (this.localstorageService.isAuthenticated()) {
      return true;
    }

    this.localstorageService.requestedUrl = url;

    this.router.navigateByUrl("/verify/gov-survey");

    return false;
  }
}
